module.exports = __webpack_public_path__ + "img/trucksAndBuses.d6aeba00.jpg";